export default {
  state: {
    gridFilters: {},
    updateGrid: false,
  },

  getters: {
    getGridFilters(state) {
      return state.gridFilters;
    },

    getUpdateGrid(state) {
      return state.updateGrid;
    },
  },

  mutations: {
    setGridFilters(state, filters) {
      state.gridFilters = filters;
    },

    setActionsData(state, data) {
      state.actionsData = data;
    },

    setUpdateGridStatus(state, status) {
      state.updateGrid = status;
    },
  },

  actions: {
    changeGridFilters(context, filters) {
      context.commit("setGridFilters", filters);
    },

    changeUpdateGridStatus(context, status) {
      context.commit("setUpdateGridStatus", status);
    },
  },
};
